export enum AdminWorkerQueries {
  listOfWorkersAdminPage = 'listOfWorkersAdminPAge',
  highlightWorker = 'highlightWorker',
}
